// appComposer — ekran zgody per post (SPEC A7; paczka 12, artboard 10).
// Klucze lustrzane z en/appComposer.ts.
//
// To jest ekran, który TikTok audytuje, więc copy jest częścią powierzchni zgodności:
//   · widoczność NIE MA wartości domyślnej — `privacy.placeholder` stoi, dopóki artysta
//     nie wybierze, `privacy.required` jest zdaniem blokady
//   · przełączniki startują wyłączone; `toggleDisabled` tłumaczy wyszarzony
//   · `musicConfirm` / `brandedPolicy` niosą wymagane odnośniki zdania zgody
// Etykiety opcji widoczności narzucone przez platformę mieszkają w tiktokPrivacy.ts.
//
// LICZBY: zdania z liczbą są zbudowane tak, żeby liczba nie rządziła rzeczownikiem
// („Posty: {n} × …”), albo mają rodzinę `_one/_few/_many`.
export const appComposer = {
  title: 'Zatwierdź swoje posty',
  subtitle: 'Postów: {n} z {total}',
  // Nota o limicie partii: adres techniczny z dawnym słowem ZOSTAJE. Baza = forma `many`.
  batchNote: 'Naraz możesz zatwierdzić maksymalnie {limit} postów.',
  batchNote_one: 'Naraz możesz zatwierdzić maksymalnie {limit} post.',
  batchNote_few: 'Naraz możesz zatwierdzić maksymalnie {limit} posty.',
  batchNote_many: 'Naraz możesz zatwierdzić maksymalnie {limit} postów.',
  batchRange: 'Zatwierdzasz {from}-{to} z {total}',
  afterBatch: 'po tej partii zostanie {n} z {total}',
  postedAs: 'Publikujesz jako',
  goesOut: 'Wyjdzie {when}',

  costLabel: 'Koszt publikacji',
  // Forma za CENĄ ({each}), nie za liczbą postów.
  costBreakdown: 'Posty: {n} × {each} tokenów',
  costBreakdown_one: 'Posty: {n} × {each} token',
  costBreakdown_few: 'Posty: {n} × {each} tokeny',
  costBreakdown_many: 'Posty: {n} × {each} tokenów',
  costTotal: '{n} tokenów',
  costTotal_one: '{n} token',
  costTotal_few: '{n} tokeny',
  costTotal_many: '{n} tokenów',
  costAfter: 'Saldo po potwierdzeniu',
  // 35-R2, rozstrzygnięcie 6: zdanie pod przyciskiem zatwierdzania zastępuje skrót
  // `appCampaigns.detail.consentsNote`, który zostaje w szczegółach planu.
  submitNote: 'Bez zgody post się nie wyśle.',

  // Pasek zbiorczy partii niesie TYLKO widoczność, komentarze i etykietę AI (decyzja 7 MAPA 12).
  bulkTitle: 'Ustaw dla wszystkich postów w tej partii ({n})',
  bulkAi: 'Etykieta AI',
  // Sesja 23 (MAPA 23, decyzja 7): jeden wiersz, grupa na każdą platformę OBECNĄ w partii.
  // „Ustaw dla wszystkich” działa w obrębie platformy, bo pola są jej własne.
  bulkTitleAll: 'Ustaw dla wszystkich postów w tej partii - osobno dla każdej platformy',
  bulkPlatform: '{platform} ({n})',
  bulkSynthetic: 'Treści syntetyczne',
  bulkExpand: 'Rozwiń trzy platformy',

  aiLabel: 'Ta treść powstała z pomocą AI',
  aiLabelNote: 'Po opublikowaniu tej etykiety nie da się usunąć.',

  processingNote: 'Po zatwierdzeniu pojawienie się posta może potrwać kilka minut.',
  musicConfirm: 'Publikując, akceptujesz Potwierdzenie wykorzystania muzyki TikTok',
  brandedPolicy: 'Zasady treści promocyjnych',
  agreeAll: 'Publikując, zatwierdzasz każdy post z ustawieniami wybranymi powyżej.',

  // Zgoda jest zapisywana per post — razem z widocznością i wersją tego ekranu.
  consentPerPost: 'Zgodę zapisujemy osobno dla każdego posta - razem z wybraną widocznością i wersją tej zgody.',
  // Ta sama zgoda, inne dopełnienie: karta Rolki nie ma widoczności do wyboru, karta Shorta
  // ma ją i deklarację „dla dzieci” (MAPA 23, art. 03 — rozjazd nazwany wprost).
  consentPerPostIg: 'Zgodę zapisujemy osobno dla każdego posta - razem z wersją tej zgody.',
  consentPerPostYt: 'Zgodę zapisujemy osobno dla każdego posta - razem z widocznością, deklaracją „dla dzieci” i wersją tej zgody.',
  // NIE „możesz anulować każdy post przed wysyłką” — po przekazaniu wycofanie może się nie udać.
  cancelBefore: 'Post możesz anulować, dopóki nie został przekazany do wysyłki.',

  editTitle: 'Tytuł',
  editCaption: 'Opis',
  // Licznik na REALNYM limicie i neutralny znacznik zwinięcia (G7-account-token2-20).
  captionCount: '{len} / {max}',
  foldMark: 'zwinięcie po {fold}',
  foldHint: 'po {fold} znakach platforma zwija opis - to tylko znacznik, nie błąd',

  reviewProgress: 'Przejrzane {n} z {total}',
  needsFix: '{n} do uzupełnienia',
  nextIncomplete: 'Do następnego niekompletnego',
  // Pager partii: licznik jest DANĄ (mono), strzałki mają własne nazwy dla czytnika.
  pager: '{n} / {total}',
  prevPost: 'Poprzedni post',
  nextPost: 'Następny post',
  // Post YouTube bez widoczności ALBO bez deklaracji „dla dzieci” liczy się raz — licznik
  // liczy POSTY, nie pola (MAPA 23, decyzja 6). Baza = forma `many`.
  needsFieldsYt: '{n} postów YouTube nie ma jeszcze tytułu, widoczności albo deklaracji „dla dzieci” - uzupełnij je, a przycisk się włączy.',
  needsFieldsYt_one: '{n} post YouTube nie ma jeszcze tytułu, widoczności albo deklaracji „dla dzieci” - uzupełnij go, a przycisk się włączy.',
  needsFieldsYt_few: '{n} posty YouTube nie mają jeszcze tytułu, widoczności albo deklaracji „dla dzieci” - uzupełnij je, a przycisk się włączy.',
  needsFieldsYt_many: '{n} postów YouTube nie ma jeszcze tytułu, widoczności albo deklaracji „dla dzieci” - uzupełnij je, a przycisk się włączy.',
  needsVisibility: '{n} postów nie ma jeszcze widoczności - uzupełnij je, a przycisk się włączy.',
  needsVisibility_one: '{n} post nie ma jeszcze widoczności - uzupełnij go, a przycisk się włączy.',
  needsVisibility_few: '{n} posty nie mają jeszcze widoczności - uzupełnij je, a przycisk się włączy.',
  needsVisibility_many: '{n} postów nie ma jeszcze widoczności - uzupełnij je, a przycisk się włączy.',
  needsAgreement: 'Zaznacz zgodę pod postami, a przycisk się włączy.',

  submit: 'Zatwierdź {n} postów',
  submit_one: 'Zatwierdź {n} post',
  submit_few: 'Zatwierdź {n} posty',
  submit_many: 'Zatwierdź {n} postów',
  submitOne: 'Zatwierdź ten post',
  remaining: 'Zostało {n} postów do zatwierdzenia',
  remaining_one: 'Został {n} post do zatwierdzenia',
  remaining_few: 'Zostały {n} posty do zatwierdzenia',
  remaining_many: 'Zostało {n} postów do zatwierdzenia',
  submitted: 'Zatwierdzono {n} · zostało {m}',

  rejected: 'Tej treści nie można opublikować',
  staleInfo: 'Pokazujemy ostatnie znane ustawienia konta - odświeżamy…',

  // ── sesja 23: trzy platformy w jednej partii (MAPA 23, art. 03) ────────────────
  // Zdanie pod tytułem mówi, czego artysta ma się spodziewać: karty NIE są takie same.
  subtitlePlatforms: 'TikTok, Instagram i YouTube w jednej partii - każda karta ma pola swojej platformy.',
  // Format posta w nagłówku karty, po nazwie platformy: „@uchwyt · Instagram · Rolka”.
  format: {
    tiktok: 'post',
    instagram: 'Rolka',
    youtube: 'Short',
  },

  // Rolka: opis i JEDEN przełącznik, którego wartość jest wartością Instagrama.
  // Liczba 125 stoi w zdaniu wprost, bo to stała platformy, nie licznik.
  ig: {
    foldHint: 'po 125 znakach Instagram zwija opis - to tylko znacznik, nie błąd',
    cover: 'Okładka · pierwsza klatka',
  },

  // Short: tytuł jest WYMAGANY, a widoczność i „dla dzieci” nie mają wartości domyślnej —
  // dokładnie tak, jak widoczność TikToka, i z tego samego powodu.
  yt: {
    title: 'Tytuł',
    titleRequired: 'wymagany',
    titleMissing: 'Wpisz tytuł - YouTube go wymaga.',
    // The literal 100, like `ig.foldHint`: a placeholder count would trip the noun gate.
    titleTooLong: 'Tytuł ma najwyżej 100 znaków.',
    captionHint: 'hashtagi z opisu trafią do tagów filmu',
    synthetic: 'Zawiera treści syntetyczne, które można wziąć za prawdziwe',
    syntheticNote: 'YouTube może dodać etykietę do filmu.',
    category: 'Kategoria: Muzyka',
  },
  // ── paczka PA (44-R2 A): blok ustawień konta w kroku Konta Planera ──────────
  plan: {
    done: 'Gotowe',
  },
} as const
